import { useApiQuery } from './useApiQuery';
import { notificationAlertsApi } from '../services/alertsApi';

export function useRecentAlerts(enabled: boolean) {
  const { data: alerts, refetch, isLoading } = useApiQuery(
    ['alerts', 'recent'],
    () => notificationAlertsApi.getRecentAlerts(10),
    {
      enabled,
      staleTime: 10000,
    },
  );

  return {
    alerts: alerts ?? [],
    refetch,
    isLoading,
  };
}
